
import { useLanguage } from '@/contexts/LanguageContext';
import translations_en from '@/translations/en';
import translations_sv from '@/translations/sv';

// Type for accessing nested translation keys
type Path<T> = 
  T extends object 
    ? { [K in keyof T]: K extends string 
        ? Path<T[K]> extends never 
          ? K 
          : `${K}.${Path<T[K]>}` 
        : never 
      }[keyof T] 
    : never;

// Get the type of our translations
type TranslationsType = typeof translations_en;
type TranslationKey = Path<TranslationsType>;

// Function to get nested properties from an object using a path string
const getNestedTranslation = (obj: any, path: string): string => {
  return path.split('.').reduce((prev, curr) => {
    return prev && prev[curr] !== undefined ? prev[curr] : undefined;
  }, obj);
};

export const useTranslation = () => {
  const { language } = useLanguage();
  
  const translations = language === 'sv' ? translations_sv : translations_en;
  
  const t = (key: TranslationKey): string => {
    const value = getNestedTranslation(translations, key as string);
    
    if (value === undefined) {
      console.warn(`Translation key not found: ${key}`);
      return key as string;
    }
    
    return value;
  };
  
  return { t, language };
};
